import { sessionStorageApi } from './storage';

const sessionPreviousLocation = sessionStorageApi('previousLocation');
const storageAfterLogin = sessionStorageApi('afterLogin');

export { sessionPreviousLocation, storageAfterLogin };
